import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCompany } from "../../../contexts/CompanyContext";
import { AdminPageHeader } from "../shared";
import { Icons } from "../../shared/Icons";
import { EmployeeProgressBoard } from "./EmployeeProgressBoard";

export const AdminEmployeeProgressPage: React.FC = () => {
  const navigate = useNavigate();
  const { company } = useCompany();
  const isCarCompany = company?.category === "car";

  useEffect(() => {
    if (company && !isCarCompany) {
      navigate("/admin/daily-cash", { replace: true });
    }
  }, [company, isCarCompany, navigate]);

  if (!isCarCompany) {
    return null;
  }

  return (
    <div className="space-y-4 sm:space-y-6 md:space-y-8 animate-fade-in">
      <AdminPageHeader
        icon={<Icons.Assignment sx={{ fontSize: 28 }} />}
        title="Funcionário"
        subtitle="Acompanhe etapas, tempos e veículos por profissional e período."
      />
      <EmployeeProgressBoard />
    </div>
  );
};
